import { Component } from '@angular/core';
import { AuthService } from '../../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { ClientService } from '../../../Services/client.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoClientForViewVM } from '../../../Model/clients/DtoClientForViewVM';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { MatDialogRef } from '@angular/material/dialog';
import { CreateClientPopupComponent } from '../create-client-popup/create-client-popup.component';
import { DialogService } from '../../../Shared/Services/dialog.service';
import { SharedService } from '../../../Shared/Services/shared.service';

@Component({
  selector: 'app-clients-list',
  templateUrl: './clients-list.component.html',
  styleUrl: './clients-list.component.scss'
})
export class ClientsListComponent {
  AllClients: DtoClientForViewVM[] = [];
  OriginalClients: DtoClientForViewVM[] = [];
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private router: Router, private auth: AuthService, private dialogService: DialogService,
    private dialogRef: MatDialogRef<ClientsListComponent>, private api: ClientService, private shared: SharedService,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery, UserType.Agent])) {
      this.spinner.show();
      this.GetAllClients();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllClients() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery, UserType.Agent])) {
      this.api.GetAllClients()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.AllClients = res.payload;
              this.OriginalClients = res.payload;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  SelectClient(client?: any) {
    this.dialogRef.close({ data: client?.id });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  CreateClient() {
    let dialogClientsList = this.dialogService.openDialog(CreateClientPopupComponent);

    dialogClientsList.afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close({ data: result?.data });
      }
    });
  }

  checkSearchVal(searchVal?: any) {
    this.AllClients = this.shared.checkSearchVal(this.AllClients, this.OriginalClients, searchVal, 'name');
  }
}
